(function () {
  'use strict';

  angular.module('app').component('clientPage', clientDetailComponent());

  function clientDetailComponent() {
    return {
      bindings: {},
      controller: ClientDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/clients/client-page.component.html',
    };
  }

  ClientDetailCtrl.$inject = ['$location', '$routeParams', 'AbilityService', 'ClientService'];

  function ClientDetailCtrl($location, $routeParams, AbilityService, ClientService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_client_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        ClientService.getClient(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/clients/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/clients');
    }
  }
})();
